import { useState, useRef, useEffect } from "react";
import "../styles/select-custom.css";
import arrowDown from '../assets/images/small/select-drop-down-arrow-gray.png'

export default function CustomSelect({
  options = [],
  value,
  onChange,
  labelKey,
  valueKey,
  placeholder = "Select option",
  selectStyle = "select-trigger",
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [openUp, setOpenUp] = useState(false);

  const ref = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOpen = () => {
    if (!open) {
      requestAnimationFrame(() => {
        if (!ref.current || !dropdownRef.current) return;

        const triggerRect = ref.current.getBoundingClientRect();
        const dropdownHeight = dropdownRef.current.offsetHeight;
        const spaceBelow = window.innerHeight - triggerRect.bottom;

        setOpenUp(spaceBelow < dropdownHeight + 10);
      });
    }
    setOpen((prev) => !prev);
  };

  const selectedOption = options.find(
    (opt) => String(opt[valueKey]) === String(value)
  );

  return (
    <div  className={`custom-select ${disabled ? "disabled" : ""}`} ref={ref}>
      <div
         className={`${selectStyle} ${open ? "open" : ""} ${
            disabled ? "disabled" : ""
        }`}
        onClick={disabled ? undefined : toggleOpen}
      >
        <span>
          {selectedOption ? selectedOption[labelKey] : placeholder}
        </span>
        <img
          src={arrowDown}
          alt="arrow"
          className={`arrow ${open ? "rotate" : ""}`}
        />
      </div>

      {open && !disabled && (
        <ul
          ref={dropdownRef}
          className={`select-options ${openUp ? "open-up" : ""}`}
        >
          {options.map((opt, index) => (
            <li
              key={`${opt[valueKey]}-${index}`}
              className={`select-option ${
                String(opt[valueKey]) === String(value) ? "active" : ""
              }`}
              onClick={() => {
                onChange(opt[valueKey]);
                setOpen(false);
              }}
            >
              {opt[labelKey]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
